import { Button, Modal, Stack, Title } from '@mantine/core';
import { IconBook, IconBrush, IconPhotoPlus } from '@tabler/icons-react';
import { useToolbar } from '../hooks/useToolbar';
import { useVariables } from '../hooks/useVariables';
import { ImageDropzone } from './ImageDropzone';

export function Toolbar() {
  const {
    uploadModalOpen,
    openUploadModal,
    closeUploadModal,
    handleAddText,
    handleAddAutoImage,
    handleImageUpload,
    handleAddAIText,
  } = useToolbar();
  
  const { variables } = useVariables();
  
  // Xử lý khi chọn file ảnh
  const handleFileChange = (file: File | null) => {
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const imageUrl = e.target?.result as string;
        handleImageUpload(imageUrl);
      };
      reader.readAsDataURL(file);
    }
  };

  return (
    <>
      <Stack gap="md" p="md">
        <Title order={4}>Công cụ</Title>
        
        <Button
          leftSection={<IconBook size={18} />}
          onClick={handleAddText}
          variant="light"
          fullWidth
        >
          Thêm văn bản
        </Button>
        
        <Button
          leftSection={<IconBook size={18} />}
          onClick={handleAddAIText}
          variant="light"
          fullWidth
        >
          Thêm AI text
        </Button>
        
        <Button
          leftSection={<IconBrush size={18} />}
          onClick={handleAddAutoImage}
          variant="light"
          fullWidth
        >
          Thêm ảnh tự động
        </Button>
        
        <Button
          leftSection={<IconPhotoPlus size={18} />}
          onClick={openUploadModal}
          variant="light"
          fullWidth
        >
          Tải lên ảnh
        </Button>
      </Stack>
      
      {/* Modal tải lên ảnh */}
      <Modal
        opened={uploadModalOpen}
        onClose={closeUploadModal}
        title="Tải lên ảnh"
        size="md"
      >
        <ImageDropzone onDrop={(files: File[]) => {
          if (files.length > 0) {
            const file = files[0];
            const reader = new FileReader();
            reader.onload = (e) => {
              const imageUrl = e.target?.result as string;
              handleImageUpload(imageUrl);
            };
            reader.readAsDataURL(file);
          }
        }} />
      </Modal>
    </>
  );
} 